/** Resolves after `milliseconds`, or rejects with an AbortError the moment `signal` aborts. */
export function abortableDelay(milliseconds: number, signal?: AbortSignal): Promise<void> {
  const { promise, resolve, reject } = Promise.withResolvers<void>()

  if (signal?.aborted) {
    reject(abortError())
    return promise
  }

  const timer = setTimeout(() => {
    signal?.removeEventListener('abort', onAbort)
    resolve()
  }, milliseconds)

  function onAbort() {
    clearTimeout(timer)
    reject(abortError())
  }

  signal?.addEventListener('abort', onAbort, { once: true })
  return promise
}

function abortError() {
  return new DOMException('Aborted', 'AbortError')
}
